import { AvatarSize } from './Avatar.types';

export const avatarImageResizeSize = (avatarSize: AvatarSize) => {
  const imageSize = {
    xs: 48,
    s: 80,
    m: 120,
    l: 160,
    xl: 200
  }[avatarSize];
  return imageSize ?? (typeof avatarSize === 'number' ? avatarSize : 48);
};
